/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var RobotFillIcon = function RobotFillIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 6.73244C13.5978 6.38663 14 5.74028 14 5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5C10 5.74028 10.4022 6.38663 11 6.73244V8H7C5.89543 8 5 8.89543 5 10V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V10C19 8.89543 18.1046 8 17 8H13V6.73244ZM7 13C7 12.4477 7.44772 12 8 12C8.55229 12 9 12.4477 9 13C9 13.5523 8.55229 14 8 14C7.44772 14 7 13.5523 7 13ZM15 13C15 12.4477 15.4477 12 16 12C16.5523 12 17 12.4477 17 13C17 13.5523 16.5523 14 16 14C15.4477 14 15 13.5523 15 13ZM11 15C10.4477 15 10 15.4477 10 16C10 16.5523 10.4477 17 11 17H13C13.5523 17 14 16.5523 14 16C14 15.4477 13.5523 15 13 15H11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 17H3.5C2.11929 17 1 15.8807 1 14.5C1 13.1193 2.11929 12 3.5 12H4L4 17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12H20.5C21.8807 12 23 13.1193 23 14.5C23 15.8807 21.8807 17 20.5 17H20V12Z"
  }));
};
export default RobotFillIcon;